import L from "leaflet";
import moment from "@/utils/moment";

export const reverse = (coords) => {
  return [coords[1], coords[0]];
};

export const decode = (encoded) => {
  var points = [];
  var index = 0,
    len = encoded.length;
  var lat = 0,
    lng = 0;
  while (index < len) {
    var b,
      shift = 0,
      result = 0;
    do {
      b = encoded.charAt(index++).charCodeAt(0) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    var dlat = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
    lat += dlat;
    shift = 0;
    result = 0;
    do {
      b = encoded.charAt(index++).charCodeAt(0) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    var dlng = (result & 1) != 0 ? ~(result >> 1) : result >> 1;
    lng += dlng;
    points.push({ latitude: lat / 1e5, longitude: lng / 1e5 });
  }
  return points;
};

export const createPolygonWithCenter = (center, zoom = 16, factor = 1) => {
  const diff = Math.max(20 - zoom, 1) * 0.0004 * factor;
  return [
    [center.lat - diff, center.lng - diff],
    [center.lat - diff, center.lng + diff],
    [center.lat + diff, center.lng + diff],
    [center.lat + diff, center.lng - diff],
  ];
};

export const splitPolylineByFares = (path) => {
  const polylines = [];
  let currentFare = null;
  let index = -1;
  path.forEach((i) => {
    if (currentFare !== i.fare) {
      currentFare = i.fare;
      index++;
      polylines[index] = [];
      if (index > 0) {
        // Add last item from previous split to this for paint a continuous line on the map
        polylines[index].push(polylines[index - 1][polylines[index - 1].length - 2]);
      }
    }
    polylines[index].push({
      lat: i.lat,
      lng: i.lon,
      fare: i.fare,
      time: moment()(i.ts).format("HH:mm:ss"),
    });
  });
  return polylines;
};

export const minDistance = (polyline, coord) => {
  const targetLatLng = L.latLng(coord.lat, coord.lng);
  const sorted = polyline.map((a) => L.latLng(a.lat, a.lng).distanceTo(targetLatLng)).sort();
  return sorted[0];
};

export const closest = (polyline, coord) => {
  const targetLatLng = L.latLng(coord.lat, coord.lng);
  return polyline.sort((a, b) => {
    const alatlng = L.latLng(a.lat, a.lng);
    const blatlng = L.latLng(b.lat, b.lng);
    return alatlng.distanceTo(targetLatLng) - blatlng.distanceTo(targetLatLng);
  })[0];
};

export const closestFromArrays = (arrayOne, arrayTwo, maximumDistance) => {
  const latLngOne = arrayOne.map((a) => L.latLng(a[1], a[0]));
  const latLngTwo = arrayTwo.map((a) => L.latLng(a[1], a[0]));
  let closestDistance = null;
  let closestLatLng = null;

  latLngOne.forEach((one) => {
    latLngTwo.forEach((two) => {
      const distance = one.distanceTo(two);
      if ((distance <= maximumDistance && closestDistance === null) || closestDistance > distance) {
        closestDistance = distance;
        closestLatLng = one;
      }
    });
  });

  if (closestLatLng) {
    return [closestLatLng.lng, closestLatLng.lat];
  }
  return null;
};

export function checkPolygonsIntersection(polygon1, polygon2) {
  for (let i = 0; i < polygon1.length; i++) {
    const p1 = polygon1[i];
    const p2 = polygon1[(i + 1) % polygon1.length];

    for (let j = 0; j < polygon2.length; j++) {
      const p3 = polygon2[j];
      const p4 = polygon2[(j + 1) % polygon2.length];

      if (doLineSegmentsIntersect(p1, p2, p3, p4)) {
        return true;
      }
    }
  }

  return isPointInPolygon(polygon1[0], polygon2) || isPointInPolygon(polygon2[0], polygon1);
}

function doLineSegmentsIntersect(p1, p2, p3, p4) {
  const d1 = direction(p3, p4, p1);
  const d2 = direction(p3, p4, p2);
  const d3 = direction(p1, p2, p3);
  const d4 = direction(p1, p2, p4);
  return ((d1 > 0 && d2 < 0) || (d1 < 0 && d2 > 0)) && ((d3 > 0 && d4 < 0) || (d3 < 0 && d4 > 0));
}

function direction(p1, p2, p3) {
  return (p3[1] - p1[1]) * (p2[0] - p1[0]) - (p2[1] - p1[1]) * (p3[0] - p1[0]);
}

function isPointInPolygon(point, polygon) {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];

    const intersect =
      yi > point[1] !== yj > point[1] && point[0] < ((xj - xi) * (point[1] - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
}
